module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-60x60-d0a1bf3555c96946f174c00c6e1562c4.png";